import type { RootBlock } from "@circle-react-shared/BuilderUI/DataModel.types";
import { v4 as uuidv4 } from "uuid";

export const defaultData: RootBlock = {
  id: uuidv4(),
  type: "root",
  props: {
    children: {
      prop: "children",
      type: "children",
      value: [],
    },
  },
};
